import {useQuery} from '@tanstack/react-query';
import {useKEIConnect} from '@kei.fi/connect';
import {tokensApi} from '@/api-requests/tokens';
import {PRIMARY_CHAIN, TOKEN_ADDRESS} from '@/util/chains';

export const useFetchAccountData = () => {
  const {signer} = useKEIConnect();
  return useQuery({
    queryKey: ['kei-account-data', signer?.address],
    enabled: !!signer?.address,
    refetchInterval: 60_000,
    staleTime: 60_000,
    queryFn: async () => {
      const [balances, transactions, blockNumber, keiToken] = await Promise.all(
        [
          tokensApi.getAccountBalances(PRIMARY_CHAIN, signer!.address),
          tokensApi.getTransactions(PRIMARY_CHAIN, signer!.address),
          signer!.provider.getBlockNumber(),
          tokensApi.getTokenInfo('kei-finance'),
        ]
      );

      const index = balances.findIndex(
        item => item.contract_ticker_symbol === 'KEI'
      );
      if (index !== -1) {
        balances.unshift(...balances.splice(index, 1));
      } else {
        balances.unshift({
          balance: '0',
          contract_decimals: 18,
          contract_name: 'KEI finance',
          contract_ticker_symbol: 'KEI',
          contract_display_name: 'KEI finance',
          ...keiToken['kei-finance'],
          contract_address: TOKEN_ADDRESS,
        } as any);
      }

      return {
        balances,
        ...transactions,
        blockNumber,
      };
    },
  });
};
